package br.com.texeratx.boardgametimeapp.ui.components

import androidx.compose.material3.AlertDialog
import androidx.compose.material3.Text
import androidx.compose.material3.TextButton
import androidx.compose.runtime.Composable
import br.com.texeratx.boardgametimeapp.core.i18n.LocalStrings

@Composable
fun ReplaceActiveMatchDialog(
    onDismiss: () -> Unit,
    onContinueCurrent: () -> Unit,
    onReplace: () -> Unit,
) {
    val S = LocalStrings.current
    AlertDialog(
        onDismissRequest = onDismiss,
        title = { Text(S.dialogActiveMatchInProgress) },
        text = {
            Text(S.dialogActiveMatchChoice)
        },
        confirmButton = {
            TextButton(onClick = onContinueCurrent) {
                Text(S.continueCurrent)
            }
        },
        dismissButton = {
            TextButton(onClick = onReplace) {
                Text(S.replace)
            }
        }
    )
}
